import { render, staticRenderFns } from "./view-body.vue?vue&type=template&id=c7233508"
import script from "./view-body.vue?vue&type=script&lang=js"
export * from "./view-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports